// extracted by mini-css-extract-plugin
export default {"container":"Album_styles_container__ZCi90","albumContainer":"Album_styles_albumContainer__ZtOfN","description":"Album_styles_description__+GBbj"};